import { ApiSanctionType } from '../../api';

export const screeningDisplayNames = {
  [ApiSanctionType.SANCTION]: 'Sanctions',
  [ApiSanctionType.PEP]: 'PEP',
  [ApiSanctionType.ADVERSE_MEDIA]: 'Adverse Media',
  [ApiSanctionType.ADVERSE_MEDIA_ENTITY]: 'Adverse Media Entity',
  [ApiSanctionType.CUSTOM_SCREENING_LIST]: 'Custom screening list',
};

export enum DowJonesCustomListCode {
  DOW_JONES_SANCTION = 'DOW_JONES_SANCTION',
  DOW_JONES_PEP = 'DOW_JONES_PEP',
  DOW_JONES_AM = 'DOW_JONES_AM',
  DOW_JONES_AME = 'DOW_JONES_AME',
}

export const dowJonesListDisplayNamesOLD = {
  [DowJonesCustomListCode.DOW_JONES_SANCTION]: screeningDisplayNames[ApiSanctionType.SANCTION] + ' Dow Jones',
  [DowJonesCustomListCode.DOW_JONES_PEP]: screeningDisplayNames[ApiSanctionType.PEP] + ' Dow Jones',
  [DowJonesCustomListCode.DOW_JONES_AM]: screeningDisplayNames[ApiSanctionType.ADVERSE_MEDIA] + ' Dow Jones',
  [DowJonesCustomListCode.DOW_JONES_AME]: screeningDisplayNames[ApiSanctionType.ADVERSE_MEDIA_ENTITY] + ' Dow Jones',
};

export const dowJonesListDisplayNames = {
  [DowJonesCustomListCode.DOW_JONES_SANCTION]: 'Dow Jones / ' + screeningDisplayNames[ApiSanctionType.SANCTION],
  [DowJonesCustomListCode.DOW_JONES_PEP]: 'Dow Jones / ' + screeningDisplayNames[ApiSanctionType.PEP],
  [DowJonesCustomListCode.DOW_JONES_AM]: 'Dow Jones / ' + screeningDisplayNames[ApiSanctionType.ADVERSE_MEDIA],
  [DowJonesCustomListCode.DOW_JONES_AME]: 'Dow Jones / ' + screeningDisplayNames[ApiSanctionType.ADVERSE_MEDIA_ENTITY],
};

export const dowJonesSanctionTypeDisplayNames = {
  [ApiSanctionType.SANCTION]: 'Dow Jones / ' + screeningDisplayNames[ApiSanctionType.SANCTION],
  [ApiSanctionType.PEP]: 'Dow Jones / ' + screeningDisplayNames[ApiSanctionType.PEP],
  [ApiSanctionType.ADVERSE_MEDIA]: 'Dow Jones / ' + screeningDisplayNames[ApiSanctionType.ADVERSE_MEDIA],
  [ApiSanctionType.ADVERSE_MEDIA_ENTITY]: 'Dow Jones / ' + screeningDisplayNames[ApiSanctionType.ADVERSE_MEDIA_ENTITY],
  [ApiSanctionType.CUSTOM_SCREENING_LIST]: screeningDisplayNames[ApiSanctionType.CUSTOM_SCREENING_LIST],
};

export const dowJonesSortOrder = [
  DowJonesCustomListCode.DOW_JONES_SANCTION,
  DowJonesCustomListCode.DOW_JONES_PEP,
  DowJonesCustomListCode.DOW_JONES_AM,
  DowJonesCustomListCode.DOW_JONES_AME,
];
